export enum LeadChannel {
  twilio = 'twilio',
  donor_app = 'donor_app',
  captain_app = 'captain_app',
  charity_app = 'charity_app',
}
